import { put2 } from "@/shared/axios";
import useDownloadHubQuery from "@/shared/queries/downloads/useDownloadHubQuery";
import { DownloadHub } from "@/shared/utils/interfaces";
import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

const useDownloadHubPut = () => {
  const { t } = useTranslation();
  const query = useDownloadHubQuery();

  const mutation = useMutation({
    mutationFn: ({ item_id, ...data }: DownloadHub) =>
      put2(`internal/secure/pos/v1/download/hub/${item_id}`, data),
    onSuccess: () => {
      toast.success(t("success.update"));
      query.refetch();
    },
  });

  return mutation;
};

export default useDownloadHubPut;
